import script from "./SlaCompliancePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SlaCompliancePanel.vue?vue&type=script&setup=true&lang=js"

import "./SlaCompliancePanel.vue?vue&type=style&index=0&id=484eac59&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-484eac59"]])

export default __exports__